/* eslint no-underscore-dangle: ["error", { "allow": ["__queryID", "__position"] }] */
import aa from "search-insights";

import { jjLogger } from "utils/logUtils";

import useSettings from "./useSettings";
import useUsers from "./useUsers";

const useAlgoliaEvents = () => {
  const {
    settings: { algolia },
  } = useSettings();
  const { currentUser } = useUsers();

  const getUser = () => {
    if (currentUser) return currentUser.id;

    let userToken;
    aa("getUserToken", null, (err, newUserToken) => {
      if (err) {
        jjLogger.log(`useAlgoliaEvents.js - getUser() - Error while generating newUserToken - ${err}`);
        return;
      }
      userToken = newUserToken;
    });
    return userToken;
  };

  const trackEventAfterSearch = (item) => {
    aa("clickedObjectIDsAfterSearch", {
      userToken: getUser(),
      eventName: "click_on_after_search",
      index: algolia.indexName,
      queryID: item.__queryID,
      objectIDs: [item.objectID],
      positions: [item.__position],
    });
  };

  return {
    trackEventAfterSearch,
  };
};

export default useAlgoliaEvents;
